import { DOCUMENT } from '@angular/common';
import { Component, Inject, Injector, OnDestroy, OnInit } from '@angular/core';
import { QuestionType } from 'models';
import { Subscription } from 'rxjs';
import { BaseComponent } from 'src/_base/base/base.component';
import { SP_Tag } from 'src/_models/panels';
import { BrowserConfig, SurveySectionsService, SurveyService } from 'src/_services';
import { StorageService } from 'src/_services/storage.service';
import { TotalsService } from 'src/_services/totals.service';
import { COMPANIES_SELECTION_QUESTION, SurveyUtility } from 'src/_utility/survey';
import { TotalsUtility } from 'utility';

const MOBILEVIEWWIDTH = 575;

@Component({
  selector: 'app-side-panel-tags',
  templateUrl: './side-panel-tags.component.html',
  styleUrl: './side-panel-tags.component.css'
})
export class SidePanelTagsComponent extends BaseComponent implements OnInit {

  tags: SP_Tag[] = [];
  total: number;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private inj: Injector,
    private survey: SurveyService,
    private surveySections: SurveySectionsService,
    private totals: TotalsService,
    private storage: StorageService
  ) {
    super(inj)
  }

  ngOnInit() {
    this.subGetTotals();
  }

  ngAfterContentChecked() {
    this.setTagsContainerHeight();
  }

  subGetTotals() {
    const totalsSub = this.totals.totalsOnLoaded.subscribe({
      next: data => {
        this.total = this.totals.getTotal('1.0')?.quantity;
        this.loadTags();
      },
      error: err => {
        //TODO: gestire gli errori
      }
    })
    this.addSubscription(totalsSub);
  }

  loadTags() {
    this.tags = [];

    const questionsAnswered = TotalsUtility.getTotalInput(this.survey.getQuestions()).Questions.filter(x => x.Code != '1.0');
    if(questionsAnswered?.length > 0) {
      questionsAnswered.forEach(q => {
        const questionObj = this.survey.getQuestionById(q.Code);
        let _id = q.Code;
        let _qId = q.Code;
        let _text: string;
        let _nProducts: number;
        if(questionObj.type == QuestionType.MultipleAnswerCheck) {
          _text = q.Answers[0].Value1;
          const answers = _text.split(',');
          if(answers?.length > 0) {
            _nProducts = 0;
            answers.forEach(a => {
              const answerObj = questionObj.answers.find(x => x.text == a);
              if(answerObj != null) {
                const t = this.totals.getTotal(answerObj.id);
                _nProducts += t?.quantity ?? 0;
              }
            });
          }
        }
        else {
          const answerObj = questionObj.answers.find(x => x.id == q.Answers[0].Code);
          _text = answerObj.tagTxt;
          _nProducts = this.totals.getTotal(answerObj.id)?.quantity ?? 0;

          if ([QuestionType.Range, QuestionType.SingleValue, QuestionType.RangeSlider].includes(questionObj.type)) {
            const value1 = q.Answers[0].Value1 && q.Code == BrowserConfig.redemptionQuestion ? (parseInt(q.Answers[0].Value1) / 12).toString() : q.Answers[0].Value1;
            const value2 = q.Answers[0].Value2;

            _text = _text?.replace(/{value1}/g, value1);
            _text = _text?.replace(/{value2}/g, value2);
          }

          if (q.Code == COMPANIES_SELECTION_QUESTION) {
            const companies = this.storage.getCompanies() ?? [];
            const selectedCompanyCodes = q.Answers[0].Value1.split(',');
            let selectedCompanies: string[] = [];
            selectedCompanyCodes.forEach(x => {
              selectedCompanies.push(companies.find(c => c.FidaCode == x)?.Name ?? x);
            });
            _text = selectedCompanies.join(',');
          }

        }

        this.tags.push({
          id: _id,
          questionId: _qId,
          text: _text,
          nProducts: _nProducts
        })
      })
    }
  }

  tagClicked(tag: SP_Tag) {
    const question = this.survey.getQuestionById(tag.questionId);
    const sectionId = SurveyUtility.getSectionIdOfQuestion(question.id);
    const section = this.surveySections.getSectionById(sectionId);
    this.surveySections.updateCurrentSection(section, question);
  }

  getTagWidth(tag: SP_Tag): string {
    if(tag?.nProducts != null && this.total != null) {
      return `${((tag.nProducts * 100) / this.total)}%`
    }

    return null
  }

  setTagsContainerHeight() {
    const tagsContEl = this.document.getElementsByClassName('tags-container')[0];
    const panelsContainer = this.document.getElementById('comparatoreMFPanels');

    if(panelsContainer != null && tagsContEl != null) {
      if(panelsContainer.offsetWidth > MOBILEVIEWWIDTH) {
        const sidePanelEl = this.document.getElementsByClassName('side-panel-container')[0];
        const spTitleEl = this.document.getElementsByClassName('side-panel-title-container')[0];
        const spProductsEl = this.document.getElementsByClassName('side-panel-products-container')[0];
        const spTagsTitleEl = this.document.getElementsByClassName('tags-title')[0];

        if(sidePanelEl != null && spTitleEl != null && spProductsEl != null && spTagsTitleEl != null) {
          const hSidePanel = (sidePanelEl as HTMLElement).offsetHeight;
          const hSpTitle = (spTitleEl as HTMLElement).offsetHeight;
          const hSpProducts = (spProductsEl as HTMLElement).offsetHeight;
          const hSpTagsTitle = (spTagsTitleEl as HTMLElement).offsetHeight;
          const paddingTagsContainer = 24;

          const totHeight = hSpTitle + hSpProducts + paddingTagsContainer + hSpTagsTitle;
          const hTagsCont = hSidePanel - totHeight - 5;

          (tagsContEl as HTMLElement).style.height = `${hTagsCont}px`;
        }
      }
      // else {
      //   (tagsContEl as HTMLElement).style.height = null;
      //   (tagsContEl as HTMLElement).style.maxHeight = '180px';
      // }
    }
  }

}
